import { Box, InputLabel, MenuItem, Select } from '@mui/material';
import { FormData, geminiModelsImage } from './constants';

export const Sizes = ['auto', '1024x1024', '1536x1024', '1024x1536'];

type Props = {
  formData: FormData;
  onChange: (e: any) => void;
};

const GeminiImage = ({ formData, onChange }: Props) => {
  return (
    <Box display={'flex'} flexDirection={'column'} gap={'16px'}>
      <Box mt={'8px'}>
        <InputLabel htmlFor="geminiModels">Gemini Models</InputLabel>
        <Select
          value={formData.model}
          onChange={onChange}
          className="nodrag"
          fullWidth
          name="model"
          sx={{
            width: '100%',
          }}
        >
          {geminiModelsImage.map(type => (
            <MenuItem key={type.value} value={type.value}>
              {type.name}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default GeminiImage;
